import Vue from "vue";
import { GetterTree, MutationTree, ActionTree } from "vuex/types/index";

export const state = () => ({
  schedules: {},
  drafts: {},
  hideAutoSchedule: true,
  entered: false
});

export type SchedulesState = {
  schedules: {};
  drafts: {};
  hideAutoSchedule: boolean;
  entered: boolean;
};

export const getters: GetterTree<SchedulesState, {}> = {
  getDraftsOfPlan(state) {
    return (id: string) => {
      return state.drafts[id] || [];
    };
  },
  getSchedulesOfPlan(state) {
    return (id: string) => {
      return state.schedules[id] || [];
    };
  }
};

export const mutations: MutationTree<SchedulesState> = {
  SET_ENTERED(state, value) {
    state.entered = value;
  },
  SET_SCHEDULES(state, { planId, data }) {
    Vue.set(state.schedules, planId, data);
  },
  ADD_DRAFT(state, { planId, data }) {
    const drafts = state.drafts[planId] || [];
    Vue.set(state.drafts, planId, [...drafts, data]);
  },
  UPDATE_DRAFT(state, { planId, draftId, data }) {
    const drafts = state.drafts[planId] || [];
    const index = drafts.findIndex(d => d.id === draftId);
    Vue.set(state.drafts[planId], index, data);
  },
  REMOVE_DRAFTS(state, planId) {
    Vue.set(state.drafts, planId, []);
  },
  REMOVE_DRAFT(state, { planId, id }) {
    let drafts = state.drafts[planId] || [];
    drafts = drafts.filter(d => d.id !== id);
    Vue.set(state.drafts, planId, drafts);
  },
  SET_HIDE_AUTO_SCHEDULE(state, value) {
    state.hideAutoSchedule = value;
  },
  DELETE_MANUAL_SCHEDULE(state, { planId, scheduleId }) {
    const schedules = state.schedules[planId] || [];
    const index = schedules.findIndex(s => s.id === scheduleId);
    Vue.set(state.schedules[planId][index], "deleted", true);
  }
};

export const actions: ActionTree<SchedulesState, {}> = {
  async loadSchedules({ commit }, id) {
    const schedules = await this.$api.hfox.getPlanSchedules(id, { limit: 0 });
    commit("SET_SCHEDULES", { planId: id, data: schedules });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
